import {React} from 'common'
import {styled, alpha} from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import {useUrlParams} from 'services/hooks'
import debounce from 'lodash/debounce'
import {useTranslation} from 'react-i18next'

const Search = () => {
    const {t} = useTranslation()
    const {setUrlParam} = useUrlParams()

    const handleInputChange = debounce((event) => {
        setUrlParam('search', event.target.value)
    }, 500)

    return (
        <Container>
            <SearchIconWrapper>
                <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
                placeholder={t('header.search')}
                inputProps={{'aria-label': 'search'}}
                onChange={handleInputChange}
            />
        </Container>
    )
}

export default Search

const Container = styled('div')(({theme}) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginInlineStart: theme.spacing(2),
    marginInlineEnd: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginInlineEnd: theme.spacing(3),
        width: 'auto',
    },
}))

const SearchIconWrapper = styled('div')(({theme}) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({theme}) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingInlineStart: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
}))
